import type { MediaItem } from "@/types";

export const mediaList: MediaItem[] = [
  {
    id: "m1",
    title: "星际回响",
    originalTitle: "Interstellar Echo",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    duration: "146分钟",
    rating: 8.7,
    popularity: 9820,
    director: "陈焱",
    cast: ["林澈", "苏昉", "顾昭"],
    synopsis:
      "一艘失联百年的探索舰突然从虫洞边缘传回信号，天体物理学家陆离被卷入一场跨越星系的追问。当人类最古老的孤独记忆被宇宙重新播响，她必须在回家与继续前行之间做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20with%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20deep%20purple%20and%20amber%20color%20grading%2C%20dramatic%20rim%20light%2C%20minimalist%20moody%20composition%2C%20high%20detail&width=400&height=600&seq=ld-poster-m1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20wide%20shot%20of%20deep%20space%20with%20a%20distant%20spaceship%20and%20swirling%20nebula%2C%20purple%20and%20amber%20toned%20sci-fi%20atmosphere%2C%20volumetric%20light%20rays%2C%20cinematic%20scale&width=1600&height=900&seq=ld-back-m1&orientation=landscape",
    tags: ["硬科幻", "太空", "高分"],
    featured: true,
  },
  {
    id: "m2",
    title: "长夜将尽",
    originalTitle: "The Long Night Ends",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2024,
    duration: "128分钟",
    rating: 8.2,
    popularity: 8650,
    director: "周慕云",
    cast: ["韩沉", "赵敏行", "白芮"],
    synopsis:
      "一起尘封十二年的旧案在暴雨夜被重新揭开，退休刑警与年轻记者联手追查真相。线索越清晰，他们越发现所有人都在守护同一个谎言。",
    poster:
      "https://readdy.ai/api/search-image?query=noir%20crime%20film%20poster%20set%20on%20a%20rainy%20dark%20street%20at%20night%2C%20silhouette%20under%20a%20street%20lamp%2C%20deep%20purple%20shadows%20with%20orange%20light%2C%20mysterious%20tense%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-m2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20rainy%20city%20street%20at%20night%20with%20reflections%20on%20wet%20asphalt%2C%20neon%20purple%20and%20warm%20orange%20glow%2C%20cinematic%20crime%20drama%20atmosphere&width=1600&height=900&seq=ld-back-m2&orientation=landscape",
    tags: ["悬疑", "烧脑", "国产"],
    featured: true,
  },
  {
    id: "m3",
    title: "雨林归途",
    originalTitle: "Way Back Through the Rainforest",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2025,
    duration: "118分钟",
    rating: 8.5,
    popularity: 7240,
    director: "沈川",
    cast: ["梁知远", "方宁", "小满"],
    synopsis:
      "为了完成父亲未竟的植物学研究，沉默寡言的城市女孩带着年迈的向导深入雨林。在潮湿与迷雾之中，她重新学会了与自然、也与自己和家人的对话。",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20drama%20film%20poster%20of%20a%20girl%20walking%20through%20a%20misty%20lush%20rainforest%2C%20soft%20emerald%20and%20violet%20tones%20with%20amber%20sunlight%2C%20emotional%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-m3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=lush%20tropical%20rainforest%20with%20morning%20mist%20and%20sunbeams%20through%20the%20canopy%2C%20violet%20shadow%20and%20warm%20amber%20light%2C%20cinematic%20nature%20documentary%20feel&width=1600&height=900&seq=ld-back-m3&orientation=landscape",
    tags: ["治愈", "亲情", "文艺"],
    featured: false,
  },
  {
    id: "m4",
    title: "机械之心",
    originalTitle: "Mechanical Heart",
    type: "movie",
    genres: ["动作", "科幻"],
    region: "韩国",
    year: 2024,
    duration: "134分钟",
    rating: 7.9,
    popularity: 8130,
    director: "朴承宇",
    cast: ["姜莱", "徐律", "崔真"],
    synopsis:
      "在机械义体普及的近未来都市，一名负责回收失控机体的赏金猎人，发现自己的心脏也是被回收清单上的一件旧货。为了活下去，他必须找到那颗心真正的主人。",
    poster:
      "https://readdy.ai/api/search-image?query=cyberpunk%20action%20film%20poster%20of%20a%20bounty%20hunter%20with%20glowing%20mechanical%20arm%2C%20deep%20purple%20cyberpunk%20city%20lights%20and%20vivid%20orange%20highlights%2C%20futuristic%20tense%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-m4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20neon%20cyberpunk%20city%20alley%20at%20night%20with%20hover%20vehicles%2C%20purple%20and%20orange%20neon%20signage%2C%20cinematic%20action%20atmosphere&width=1600&height=900&seq=ld-back-m4&orientation=landscape",
    tags: ["动作", "赛博", "爽片"],
    featured: false,
  },
  {
    id: "m5",
    title: "南方来客",
    originalTitle: "The Visitor from the South",
    type: "movie",
    genres: ["剧情", "文艺"],
    region: "法国",
    year: 2023,
    duration: "112分钟",
    rating: 8.0,
    popularity: 5320,
    director: "艾玛·洛朗",
    cast: ["保罗·梅西耶", "克莱尔·杜邦"],
    synopsis:
      "一个小镇旅馆在淡季迎来一位没有行李的客人。他用三天时间，把镇上每个人心里藏了很久的话都问了出来，也包括他自己一直不愿回答的那个问题。",
    poster:
      "https://readdy.ai/api/search-image?query=artistic%20european%20drama%20poster%20of%20a%20solitary%20traveler%20at%20a%20seaside%20hotel%20window%2C%20muted%20violet%20and%20soft%20orange%20sunset%20tones%2C%20melancholic%20elegant%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-m5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=quiet%20french%20seaside%20town%20at%20golden%20dusk%20with%20empty%20cafe%20tables%2C%20soft%20violet%20sky%20and%20warm%20orange%20sunset%2C%20cinematic%20melancholic%20mood&width=1600&height=900&seq=ld-back-m5&orientation=landscape",
    tags: ["文艺", "治愈", "口碑"],
    featured: false,
  },
  {
    id: "t1",
    title: "长安夜行",
    originalTitle: "Night Walk in Chang'an",
    type: "tv",
    genres: ["古装", "权谋"],
    region: "中国大陆",
    year: 2025,
    duration: "全40集",
    rating: 8.8,
    popularity: 11450,
    director: "江知白",
    cast: ["谢无咎", "云舒", "裴之衡"],
    synopsis:
      "盛世长安的繁华之下，暗流涌动。一位被贬的少卿与一名身份成谜的乐师，在夜色中联手追查一桩牵动朝局的旧案，一步踏错便是万丈深渊。",
    poster:
      "https://readdy.ai/api/search-image?query=chinese%20historical%20drama%20poster%20of%20an%20official%20in%20flowing%20robes%20under%20lanterns%20at%20night%2C%20deep%20purple%20and%20warm%20orange%20lantern%20glow%2C%20elegant%20ancient%20capital%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-t1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20street%20at%20night%20full%20of%20red%20lanterns%20and%20mist%2C%20deep%20purple%20sky%20with%20orange%20lantern%20light%2C%20cinematic%20historical%20drama%20atmosphere&width=1600&height=900&seq=ld-back-t1&orientation=landscape",
    tags: ["古装", "权谋", "爆款"],
    featured: true,
  },
  {
    id: "t2",
    title: "午夜急诊室",
    originalTitle: "Midnight ER",
    type: "tv",
    genres: ["医疗", "剧情"],
    region: "中国大陆",
    year: 2024,
    duration: "全36集",
    rating: 8.4,
    popularity: 9310,
    director: "苏沐",
    cast: ["顾清和", "罗壹", "丁晓"],
    synopsis:
      "每个午夜，急诊室的大门都会推开一个不同的故事。年轻的主治医生在一场场与时间赛跑的抢救中，慢慢拼回自己破碎的职业信念。",
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20poster%20of%20a%20young%20doctor%20in%20scrubs%20standing%20in%20a%20hospital%20corridor%20at%20night%2C%20cool%20purple%20tones%20with%20warm%20orange%20lamp%20light%2C%20urgent%20hopeful%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-t2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=night%20hospital%20emergency%20room%20corridor%20with%20soft%20glowing%20lights%20and%20blurred%20figures%2C%20cool%20purple%20and%20warm%20amber%20accents%2C%20cinematic%20drama%20atmosphere&width=1600&height=900&seq=ld-back-t2&orientation=landscape",
    tags: ["医疗", "群像", "催泪"],
    featured: false,
  },
  {
    id: "t3",
    title: "雾都谜案",
    originalTitle: "The Fog City Case",
    type: "tv",
    genres: ["悬疑", "推理"],
    region: "英国",
    year: 2024,
    duration: "全8集",
    rating: 8.9,
    popularity: 8760,
    director: "奥利弗·格兰特",
    cast: ["艾米莉·哈特", "詹姆斯·科尔"],
    synopsis:
      "浓雾笼罩的港口城市接连发生离奇失踪案。一位被停职的探长与一名犯罪心理学教授，被迫组成最不情愿的搭档，越查越接近彼此的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=british%20mystery%20series%20poster%20of%20a%20detective%20silhouette%20in%20thick%20fog%20lit%20by%20a%20street%20lamp%2C%20deep%20purple%20and%20amber%20tones%2C%20eerie%20tense%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-t3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=foggy%20british%20harbor%20street%20at%20night%20with%20dim%20street%20lamps%20and%20old%20buildings%2C%20deep%20purple%20fog%20with%20orange%20lamp%20glow%2C%20cinematic%20mystery%20atmosphere&width=1600&height=900&seq=ld-back-t3&orientation=landscape",
    tags: ["悬疑", "推理", "英剧"],
    featured: false,
  },
  {
    id: "t4",
    title: "海岸线之恋",
    originalTitle: "Love on the Coastline",
    type: "tv",
    genres: ["都市", "爱情"],
    region: "韩国",
    year: 2025,
    duration: "全16集",
    rating: 7.8,
    popularity: 7980,
    director: "郑恩彩",
    cast: ["李周宪", "韩素希", "朴道贤"],
    synopsis:
      "一个回到海边小城开冲浪店的前建筑师，遇见了来此躲避都市生活的纪录片导演。两个都以为不会再心动的人，在潮汐的往复里重新学会了靠近。",
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20korean%20drama%20poster%20of%20a%20couple%20on%20a%20sunset%20coastline%2C%20soft%20violet%20sky%20with%20warm%20orange%20sunset%2C%20tender%20dreamy%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-t4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=beautiful%20coastline%20at%20sunset%20with%20gentle%20waves%20and%20distant%20surfboards%2C%20soft%20violet%20sky%20and%20orange%20glow%2C%20cinematic%20romantic%20atmosphere&width=1600&height=900&seq=ld-back-t4&orientation=landscape",
    tags: ["爱情", "治愈", "韩剧"],
    featured: false,
  },
  {
    id: "t5",
    title: "硅谷风云",
    originalTitle: "Silicon Storm",
    type: "tv",
    genres: ["商战", "科技"],
    region: "美国",
    year: 2023,
    duration: "全10集",
    rating: 8.3,
    popularity: 8120,
    director: "丹尼尔·里德",
    cast: ["埃文·斯通", "玛雅·罗德"],
    synopsis:
      "一家濒临倒闭的初创公司在一次意外的技术突破后突然被资本疯抢。创始人必须在扩张、背叛与初心之间，做出能让公司活下来的每一次选择。",
    poster:
      "https://readdy.ai/api/search-image?query=tech%20business%20drama%20poster%20of%20a%20startup%20founder%20before%20a%20glowing%20data%20wall%2C%20deep%20purple%20and%20orange%20accent%20lighting%2C%20intense%20modern%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-t5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=modern%20tech%20office%20at%20night%20with%20glowing%20screens%20and%20silhouettes%2C%20deep%20purple%20ambient%20light%20with%20orange%20screen%20glow%2C%20cinematic%20corporate%20drama%20feel&width=1600&height=900&seq=ld-back-t5&orientation=landscape",
    tags: ["商战", "科技", "美剧"],
    featured: false,
  },
  {
    id: "v1",
    title: "极限挑战星球",
    originalTitle: "Extreme Planet Challenge",
    type: "variety",
    genres: ["竞技", "真人秀"],
    region: "中国大陆",
    year: 2025,
    duration: "每周五更新",
    rating: 8.1,
    popularity: 10520,
    director: "总导演 何川",
    cast: ["极限家族"],
    synopsis:
      "六位嘉宾组成极限家族，被投放到世界各地的极端环境完成看似不可能的任务。冰川、沙漠、丛林、火山，笑点与汗水一起上桌。",
    poster:
      "https://readdy.ai/api/search-image?query=energetic%20reality%20show%20poster%20of%20a%20group%20of%20adventurers%20on%20a%20mountain%20peak%2C%20vivid%20orange%20and%20deep%20purple%20graphic%20style%2C%20bold%20playful%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-v1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sweeping%20extreme%20landscape%20with%20mountains%20and%20desert%20under%20dramatic%20sky%2C%20vivid%20orange%20sunset%20with%20deep%20purple%20clouds%2C%20cinematic%20adventure%20scale&width=1600&height=900&seq=ld-back-v1&orientation=landscape",
    tags: ["真人秀", "爆笑", "户外"],
    featured: true,
  },
  {
    id: "v2",
    title: "声生不息·宝藏季",
    originalTitle: "Endless Voices",
    type: "variety",
    genres: ["音乐", "竞演"],
    region: "中国大陆",
    year: 2024,
    duration: "全12期",
    rating: 8.6,
    popularity: 9640,
    director: "总导演 林汐",
    cast: ["宝藏歌手群像"],
    synopsis:
      "来自不同年代、不同风格的歌手同台，用一首首藏在时光里的宝藏歌曲重新对话。这里有竞技，但更多的是被音乐唤醒的共同记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=music%20competition%20show%20poster%20of%20a%20singer%20silhouette%20under%20a%20spotlight%20with%20stage%20lights%2C%20deep%20purple%20stage%20with%20warm%20orange%20beam%2C%20emotional%20powerful%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-v2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=grand%20concert%20stage%20with%20beams%20of%20light%20and%20haze%2C%20deep%20purple%20and%20warm%20orange%20spotlights%2C%20cinematic%20live%20music%20atmosphere&width=1600&height=900&seq=ld-back-v2&orientation=landscape",
    tags: ["音乐", "竞演", "情怀"],
    featured: false,
  },
  {
    id: "v3",
    title: "美食狂想曲",
    originalTitle: "Gourmet Rhapsody",
    type: "variety",
    genres: ["美食", "生活"],
    region: "日本",
    year: 2025,
    duration: "每周三更新",
    rating: 8.0,
    popularity: 6890,
    director: "总导演 山田悠",
    cast: ["美食探索团"],
    synopsis:
      "三位主厨背上行囊，走进街头巷尾寻找被遗忘的家常味道。每一集都从一桌饭菜开始，最后落到一段关于人的故事。",
    poster:
      "https://readdy.ai/api/search-image?query=cozy%20food%20show%20poster%20of%20a%20steaming%20bowl%20of%20noodles%20on%20a%20rustic%20table%2C%20warm%20orange%20light%20with%20soft%20violet%20shadows%2C%20appetizing%20warm%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-v3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rustic%20kitchen%20table%20filled%20with%20colorful%20home%20cooked%20dishes%20and%20warm%20lanterns%2C%20warm%20orange%20light%20with%20violet%20shadows%2C%20cinematic%20food%20show%20atmosphere&width=1600&height=900&seq=ld-back-v3&orientation=landscape",
    tags: ["美食", "治愈", "日综"],
    featured: false,
  },
  {
    id: "v4",
    title: "脱口秀夜现场",
    originalTitle: "Stand-up Night Live",
    type: "variety",
    genres: ["喜剧", "脱口秀"],
    region: "中国大陆",
    year: 2024,
    duration: "每周六更新",
    rating: 8.2,
    popularity: 8470,
    director: "总导演 谭野",
    cast: ["厂牌卡司群像"],
    synopsis:
      "一群最敢说的年轻人站上同一方舞台，把生活的荒诞、职场的辛酸和爱情的狼狈，全部变成让你笑出声的三分钟。",
    poster:
      "https://readdy.ai/api/search-image?query=stand-up%20comedy%20show%20poster%20of%20a%20performer%20with%20a%20microphone%20under%20a%20spotlight%2C%20deep%20purple%20background%20with%20bold%20orange%20graphic%20elements%2C%20playful%20bold%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-v4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dark%20comedy%20club%20stage%20with%20a%20single%20microphone%20and%20spotlight%2C%20deep%20purple%20room%20with%20warm%20orange%20spotlight%2C%20cinematic%20stand-up%20atmosphere&width=1600&height=900&seq=ld-back-v4&orientation=landscape",
    tags: ["脱口秀", "爆笑", "犀利"],
    featured: false,
  },
  {
    id: "v5",
    title: "旅途的答案",
    originalTitle: "The Answer of the Journey",
    type: "variety",
    genres: ["旅行", "纪实"],
    region: "中国大陆",
    year: 2023,
    duration: "全10期",
    rating: 8.4,
    popularity: 6120,
    director: "总导演 陆遥",
    cast: ["行走小组"],
    synopsis:
      "不做攻略，不赶行程。三位主持人带着一个问题出发，用一整段旅程去寻找答案。风景会过去，但旅途里遇见的人会留下来。",
    poster:
      "https://readdy.ai/api/search-image?query=travel%20documentary%20poster%20of%20travelers%20on%20an%20empty%20road%20at%20golden%20hour%2C%20soft%20violet%20sky%20with%20warm%20orange%20sunlight%2C%20calm%20reflective%20mood%2C%20high%20detail&width=400&height=600&seq=ld-poster-v5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=endless%20country%20road%20through%20rolling%20hills%20at%20golden%20hour%2C%20soft%20violet%20sky%20and%20warm%20orange%20light%2C%20cinematic%20travel%20documentary%20feel&width=1600&height=900&seq=ld-back-v5&orientation=landscape",
    tags: ["旅行", "纪实", "治愈"],
    featured: false,
  },
];